import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Grid, Tab, Typography } from "@mui/material";
import { useParsed, useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { useState } from "react";
import { EventStatistic } from "types/event";
import EventEntries from "./EventEntries";
import EventPayments from "./EventPayments";
import EventRsvps from "./EventRsvps";
import { useBranch } from "../../../provider/BranchProvider";

export default function EventStatistics() {
  const { id } = useParsed();
  const { queryResult } = useShow<EventStatistic>({
    resource: "events/statistics",
    id,
  });
  const [selectedTab, setSelectedTab] = useState<
    "entries" | "payments" | "rsvps"
  >("entries");

  const branch = useBranch();

  const statistics: EventStatistic | undefined = queryResult.data?.data;

  if (!statistics) return <></>;

  const coinsTransferred = (
    statistics.transfers.reduce((total, transfer) => {
      return (
        total +
        (transfer.name === branch?.coin?.name ? transfer.amount || 0 : 0)
      );
    }, 0) / 100
  ).toFixed(2);

  return (
    <Show
      title={
        <Typography variant="h5">
          {statistics.event.title} Statistics
        </Typography>
      }
    >
      <Grid container spacing={10} justifyContent={"center"}>
        <Grid item textAlign="center">
          <Typography variant="h3">{statistics.guestCount}</Typography>
          <Typography variant="subtitle1">Total Guests</Typography>
        </Grid>
        <Grid item textAlign="center">
          <Typography variant="h3">{coinsTransferred}</Typography>
          <Typography variant="subtitle1">Coin transferred</Typography>
        </Grid>
      </Grid>

      <Box sx={{ width: "100%", typography: "body1" }} marginTop={2}>
        <TabContext value={selectedTab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={(_, value) => setSelectedTab(value)}
              aria-label=""
            >
              <Tab label={"Entries"} value="entries" />
              <Tab label={"Payments"} value="payments" />
              {statistics.event.rsvpEnabled && (
                <Tab label={"Attendances"} value="rsvps" />
              )}
            </TabList>
          </Box>
          <TabPanel value="entries">
            <EventEntries />
          </TabPanel>
          <TabPanel value="payments">
            <EventPayments />
          </TabPanel>
          <TabPanel value="rsvps">
            <EventRsvps />
          </TabPanel>
        </TabContext>
      </Box>
    </Show>
  );
}
